module.exports = function() {
  return new Worker(__webpack_public_path__ + "aef6a6b07f089cf9ab62.worker.js");
};